import { gql } from '@apollo/client'

export const PLAYER_SEARCH = gql(`
  query FilterPlayerDetails($input: filterPlayerDetailsInput) {
    filterPlayerDetails(input: $input) {
      nTotalCount
      aPlayerDetails {
        sFullName
        sPlayingRole
        sCountryFull
        eTagStatus
        oImg {
          sUrl
        }
        oSeo {
          sSlug
        }
        oTeam {
          oImg {
            sUrl
          }
        }
        dBirthDate
        aRanking {
          eMatchType
          nRank
          nRating
        }
      }
    }
  }
`)

export const GET_TRENDING_PLAYERS = gql(`
query GetTrendingPlayers {
    getTrendingPlayers {
      sName
      nRank
      sTeam
      nRating
      eRankType
      eMatchType
      oPlayer {
        sFullName
        oImg {
          sText
          sCaption
          sAttribute
          sUrl
        }
        sCountryFull
        oSeo {
          sSlug
        }
        oTeam {
          oImg {
            sUrl
          }
        }
      }
    }
  }
`)
